import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { useRemoveOrganizationalUnit } from "@planzone/view-models";
import { Props } from "./types";
import styles from "./styles.scss";

function OrganizationalUnitRemoval({ cancel, organizationalUnit }: Props) {
  const { t } = useTranslation();
  const { removeOrganizationalUnit, isRequestPending } =
    useRemoveOrganizationalUnit();

  return (
    <Modal
      header={t("obsPage.removal.title")}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.main}>
        <div className={styles.group}>
          <p className={styles.text}>
            {t("obsPage.removal.confirmation", {
              name: organizationalUnit.name,
            })}
          </p>
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("obsPage.removal.cancel")}
          </Button>
          <Button
            type="delete"
            status={isRequestPending ? "pending" : "none"}
            press={() => removeOrganizationalUnit(organizationalUnit)}
          >
            {t("obsPage.removal.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { OrganizationalUnitRemoval };
